import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20art%20background%2C%20beautiful%20abstract%20illustration%20with%20warm%20coral%20and%20cream%20tones%2C%20soft%20gradient%20with%20flowing%20organic%20shapes%2C%20dreamy%20atmospheric%20art%2C%20elegant%20and%20artistic%2C%20subtle%20texture%2C%20no%20text%2C%20clean%20aesthetic%20background%20suitable%20for%20web%20hero%20section&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫漫画网 - 韩国漫画大全"
        title="韩漫漫画网 - 韩国漫画大全推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full">
          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            韩国漫画大全
          </h1>
          <p className="text-sm md:text-lg text-white/90 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
            汇集最新热门韩国漫画推荐，提供无删减韩国漫画排行榜，帮助您快速找到优质漫画，享受免费阅读乐趣。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              浏览全部漫画
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-white/15 text-white font-medium rounded-lg hover:bg-white/25 backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}